










import { Component, Vue, Prop, Provide } from 'nuxt-property-decorator';

@Component
export default class ModalImageGalleryWrapper extends Vue {
  @Prop({ type: String, required: true })
  labelledBy!: string

  // TODO: Add images type
  @Prop({ type: Array, required: true })
  images!: any[]

  modalOpen: boolean | number = false;
  imageComponents: Vue[] = [];

  @Provide()
  registerImage (instance: Vue) {
    this.imageComponents.push(instance);
  }

  @Provide()
  openModalOnClick (instance: Vue) {
    this.modalOpen = this.imageComponents.findIndex(e => e._uid === instance._uid) + 1;
  }
}
